<template>
  <div>
    <mu-dialog :open="dialog" @close="close" style="width: 1024px" dialogClass="coverPhotoDialog">
      <mu-flexbox align="center" justify="center" style="height: 300px;" v-if="!isCropperVisible">
        <mu-flexbox-item align="center">
          <div v-if="isUploading">
            <h2>Just a moment</h2>
          </div>
          <mu-raised-button
            v-if="!isUploading"
            icon="photo"
            label="Select image"
            @click.native="openInput"
          ></mu-raised-button>
        </mu-flexbox-item>
      </mu-flexbox>
      <vue-base64-file-upload
        v-show="false"
        disable-preview
        placeholder="Tap to change cover photo"
        accept="image/png,image/jpeg"
        :max-size="customImageMaxSize"
        @size-exceeded="onSizeExceeded"
        @load="onLoad"
      ></vue-base64-file-upload>
      <div ref="imageCropper" v-show="isCropperVisible && isCropperVisible"></div>
      <mu-card-actions align="center" v-show="!isUploading && isCropperVisible">
        <mu-icon-button
          tooltip="Cancel"
          icon="close"
          label="Cancel"
          @click.native="cancel()"
        ></mu-icon-button>
        <mu-icon-button
          tooltip="Rotate left"
          icon="rotate_left"
          @click.native="rotate('left')"
        ></mu-icon-button>
        <mu-icon-button
          tooltip="Rotate right"
          icon="rotate_right"
          @click.native="rotate('right')"
        ></mu-icon-button>
        <mu-circular-progress :size="16" v-show="isUploading"></mu-circular-progress>
        <mu-raised-button
          secondary
          icon="crop"
          :label="isUploading ? 'Uploading...': 'Crop & Upload'"
          @click.native="doCrop()"
        ></mu-raised-button>
      </mu-card-actions>
      <div v-if="isUploading">Uploading...</div>
      <mu-linear-progress v-if="isUploading" mode="determinate" :value="completionPercentage"></mu-linear-progress>
    </mu-dialog>
  </div>
</template>
<script>
  import { TweenMax, TweenLite, Power3, ScrollToPlugin } from 'gsap/all'
  const plugins = [ ScrollToPlugin];

  import ProfileApi from "../../../api/Profile"
  import VueBase64FileUpload from 'vue-base64-file-upload';
  import Croppie from 'croppie'
  
  import axios from 'axios'
  import config from '../../../config'
  import CropperMixin from '../../../mixins/CropperMixin'
  import ScrollerMixin from '../../../mixins/ScrollerMixin'
  
  export default {
    mixins: [CropperMixin, ScrollerMixin],
    components: {
      VueBase64FileUpload
    },
    name: 'add-profile-cover',
    data() {
      return {
        title: "Update cover photo",
        dialog: false,
        customImageMaxSize: 2,
        image: "",
        isUploading: false,
        isCropperVisible: false,
        cropper: undefined,
        completionPercentage: 0
      }
    },
    mounted() {
      let self = this;
      self.open();
      let url;
      if (self.activeProfile.information.basic.cover_photo !== "") {
        url = self.activeProfile.information.basic.cover_photo
      }
      else {
        url = 'static/avatar.png'
      }
      const wait = setTimeout(function () {
        const el = self.$refs['imageCropper'];
        if (el)
          self.cropper = new Croppie(el, {
            size: 'viewport',
            viewport: {width: 1024, height: 400},
            boundary: {width: 1024, height: 400},
            showZoomer: false,
            enableOrientation: true
          });
        self.cropper.bind({
          url: url,
          orientation: 4
        });
        clearTimeout(wait);
      }.bind(self), 500)
    },
    methods: {
      open() {
        this.dialog = true
      },
      close() {
        this.dialog = false;
        this.$emit('coverClosed', 'cover');
      },
      doCrop() {
        let self = this;
        self.isUploading = true;
        self.isCropperVisible = false;
        self.cropper.result('base64')
          .then(function (image) {
            const xhrProgress = {
              onUploadProgress: progressEvent => {
                self.completionPercentage = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
              }
            };
            axios.post(config.apiUrl + 'upload/user/cover/', {image: image}, xhrProgress).then(function (response) {
              self.close();
              self.$store.state.activeProfileObject.information.basic.cover_photo = response.data.rows.original;
              self.$store.state.user.cover_photo = response.data.rows.original;
              TweenLite.to(self.scroller, 0.2, {
                scrollTo: {
                  y: 0
                }
              })
            });
          })
          .catch(function () {
            self.$toastr.error("Error updating cover photo")
            self.isUploading = false;
          })
      }
    },
    computed: {
      activeProfile() {
        let self = this;
        return self.$store.state.activeProfileObject;
      }
    },
    beforeDestroy() {
      let self = this;
      if (self.cropper !== undefined) {
        self.cropper.destroy();
      }
    }
  }

</script>
<style>
  .coverPhotoDialog {
    min-width: 1070px !important;
  }
</style>



// WEBPACK FOOTER //
// AddProfileCover.vue?e6be802e